import GET_ARTICLES from "../class/getArticles";
import pickupBlock from "../class/pickup-block";

const [d] = [document];
const domReady = TPL => {
  new BLOCKS;
  new pickupBlock;
  let Mv = document.querySelector('.mainvisual');
  window.addEventListener('load', function() {
    Mv.classList.add('loaded');
  });
};

class BLOCKS {
  constructor() {
    this.news();
  }
  news () {
    //NEWS
    const getArticle = new GET_ARTICLES('.block-topics .topic_list[data-plugin="getArticles"]');
    getArticle.makeItem = (item,content) => `
    <li>
      <a href="${item.href}">
        <figure class="">
          <img src="${item.thumb}" alt="" loading="lazy">
        </figure>
        <div class="text_wrap">
          <p class="info">
            <span class="cate">${item.category.name}</span>
            <span class="date">${item.date}</span>
          </p>
          <p class="ttl${(item.is_new)? ' is-new': ''}"><span>${item.title}</span></p>
        </div>
      </a>
    </li>`;
    // getArticle.makeItem = (item) => console.log(item);
    getArticle.render();
  }

}

const jqInit = () => false;

const onload = () => {
  
  $(window).on('scroll', function(){
    let wrapPt = $('.scroll_wrap').offset().top;
    let mk2 = $('.mark2').offset().top;
    let mk3 = $('.mark3').offset().top;
    
    if(mk2 < wrapPt && wrapPt < mk3 ){
      $('.point_wrap').removeClass('here')
      $('.point2').addClass('here');
      $('.pager a').removeClass('current');
      $('.pager .p2').addClass('current');
    } else if(mk3 <= wrapPt){
      $('.point_wrap').removeClass('here')
      $('.point3').addClass('here');
      $('.pager a').removeClass('current');
      $('.pager .p3').addClass('current');
    } else {
      $('.point_wrap').removeClass('here')
      $('.point1').addClass('here');
      $('.pager a').removeClass('current');
      $('.pager .p1').addClass('current');
    }
    
    let scrollWpH = $('.scroll_wrap').height() / 2;
    let scrollSt = $('.block-strength').offset().top + scrollWpH;
    let scrollEd = $('.block-strength').offset().top + $('.block-strength').height() - scrollWpH;
    let H = $(window).height();
    let scroll = $(this).scrollTop();
    let scrollCt = scroll + H / 2;
    if(scrollCt > scrollSt && scrollEd > scrollCt){
      $('.scroll_wrap').removeClass('stop');
      $('.scroll_wrap').addClass('fixed');
    } else if (scrollCt > scrollEd){
      $('.scroll_wrap').removeClass('fixed');
      $('.scroll_wrap').addClass('stop');
    } else {
      $('.scroll_wrap').removeClass('stop');
      $('.scroll_wrap').removeClass('fixed');
    }
  });

  let today = new Date();
  $('.birth').each(function () {
    let birthDate = new Date('1952/12/1');
    let age = today.getFullYear() - birthDate.getFullYear();
    let month = today.getMonth() - birthDate.getMonth();
    if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    $(this).append(age);
  });
}


export default function HOME () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );
  
  $(() => jqInit());

  $(window).on('load', onload );
}

